<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :row-style="rowStyleFun" @afterFetchOriginalData="afterFetchOriginalData" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.customer.account')" prop="clientCode">
            <!-- <BjInput v-model="queryParams.clientCode" :placeholder="$t('AccountManagement.customer.account')" @keyup.enter.native="handleQuery" /> -->
            <BjSelectLov v-model="queryParams.clientCode" :option-list="newClientCode" :placeholder="$t('AccountManagement.customer.account')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.customer.name')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.customer.status')" prop="enabled">
            <BjSelectLov v-model="queryParams.enabled" :option-list="STATUS_ENABLED_TRUE" :placeholder="$t('AccountManagement.customer.status')"  @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.isfreeze')" prop="lock">
            <BjSelectLov v-model="queryParams.lock" :option-list="STATUS_FROZEN_TRUE" :placeholder="$t('AccountManagement.common.isfreeze')"  @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagement.common.isLeave')" prop="isDeparture">
            <BjSelectLov v-model="queryParams.isDeparture" :option-list="STATUS_EXITED_USER" :placeholder="$t('AccountManagement.common.isLeave')"  @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('DetailsOfThirdPartySalesOrder.employee')" prop="csgSales">
            <BjSelectLov v-model="queryParams.csgSales" :option-list="csgSalesList" :placeholder="$t('DetailsOfThirdPartySalesOrder.employee')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <!-- 客服 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('workOrderList.Customer')" prop="csgCustomer">
            <BjSelectLov v-model="queryParams.csgCustomer" :option-list="customerNameList" :placeholder="$t('workOrderList.Customer')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountManagementAdd.customerInfo.industry')">
            <BjSelectLov v-model="queryParams.industryList" :option-list="industryList" :placeholder="$t('AccountManagementAdd.customerInfo.industry')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessUserCustomerAddCSG type="primary" class="main-btn" @click="addCustom">{{ $t('AccountManagement.common.NewCustom') }}</el-button>
          <el-button v-permission:BusinessUserCustomerOffline type="primary" class="main-btn" @click="letOffLine">{{ $t('bulkLogoutText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <vxe-table-column v-if="col.prop === 'clientCode'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'realName'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'companyName'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'enabled'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'">
            <template #header>
              {{ col.label }}
              <el-tooltip placement="top">
                <span slot="content">{{ $t('AccountManagement.table.disableTip') }}</span>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <el-tag :type="row.enabled ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(row.enabled)) }}</el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="col.prop === 'locked'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'">
            <template #header>
              {{ col.label }}
              <el-tooltip placement="top">
                <span slot="content">{{ $t('AccountManagement.table.lockTip') }}</span>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <el-tag :type="row.locked ? 'success' : 'info'">{{ $t(STATUS_YES_TRUE.bjGet(row.locked)) }}</el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="col.prop === 'lock'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'">
            <template #header>
              {{ col.label }}
              <el-tooltip placement="top">
                <span slot="content">{{ $t('AccountManagement.table.freezeTip') }}</span>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <span v-if="row.lock == null"> </span>
              <el-tag v-else :type="row.lock ? 'success' : 'info'">{{ $t(STATUS_YES_TRUE.bjGet(row.lock)) }}</el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="col.prop === 'isDeparture'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" >
            <template slot-scope="{ row }">
              <span v-if="row.isDeparture == null"> </span>
              <el-tag v-else :type="!row.isDeparture ? 'success' : 'danger'">{{ $t(STATUS_EXITED_USER.bjGet(row.isDeparture)) }}</el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="col.prop === 'protectEndTime'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'cusName'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'csgSales'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'csgCustomer'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'createdName'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'creationDate'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'startDateActive'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'industry'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />
          <vxe-table-column v-if="col.prop === 'endDateActive'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" align="center" :field="col.prop" :title="col.label" :min-width="col.width || 'auto'" />

          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :min-width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button v-permission:BusinessUserCustomerEditCSG type="text" class="edit-btn" @click="toPage(scope.row)">{{ $t('AccountManagement.common.edit') }}</el-button>
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, scope.row)">
                <span class="el-dropdown-link">
                  {{ $t('AccountManagement.common.operate') }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">  
                  <el-dropdown-item v-if="!scope.row.isDeparture" v-permission:BusinessUserRolelndex_EditTwo :command="$t('AccountManagement.common.Info')">{{ $t('AccountManagement.common.Info') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture" :command="$t('AccountManagement.common.Change')">{{ $t('AccountManagement.common.Change') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture" :command="$t('WarehouseManagement.form.Shipping')"> {{ $t('WarehouseManagement.form.Shipping') }} </el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && !scope.row.enabled" :command="$t('enableText')">{{ $t('enableText') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && scope.row.enabled" :command="$t('disableText')">{{ $t('disableText') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && scope.row.enabled && !scope.row.lock" v-permission:BusinessUserRolelndex_Frozen :disabled="lockDisabled(scope.row)" :command="$t('AccountManagement.common.freeze')">{{ $t('AccountManagement.common.freeze') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && scope.row.enabled && scope.row.lock" v-permission:BusinessUserRolelndex_Frozen :command="$t('AccountManagement.common.unfreeze')">{{ $t('AccountManagement.common.unfreeze') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && scope.row.enabled && !scope.row.locked" :command="$t('AccountManagement.common.lock')">{{ $t('AccountManagement.common.lock') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture && scope.row.enabled && scope.row.locked" :command="$t('AccountManagement.common.deblocking')">{{ $t('AccountManagement.common.deblocking') }}</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.isDeparture" :command="$t('AccountManagement.common.Leave')">{{ $t('AccountManagement.common.Leave') }}</el-dropdown-item>
                  <el-dropdown-item v-else :command="$t('AccountManagement.common.Back')">{{ $t('AccountManagement.common.Back') }}</el-dropdown-item>
                  <el-dropdown-item :command="$t('delText')" class="delete-btn">{{ $t('delText') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog v-if="passDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :title="title" :visible.sync="passDialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" status-icon :rules="rules" label-position="top" label-width="100px">
        <el-form-item :label="$t('AccountManagement.common.password')" prop="pass">
          <BjInput v-model="form.pass" autocomplete="off" show-password />
        </el-form-item>
        <el-form-item :label="$t('AccountManagement.common.Confirm')" prop="checkPass">
          <BjInput v-model="form.checkPass" autocomplete="off" show-password />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <dialog-company ref="dialogCompany" @reFresh="reFresh"></dialog-company>

    <el-dialog :visible.sync="dialogFormVisible" width="400px">
      <el-form ref="form">
        <el-form-item prop="quantity" :label="$t('AccountManagement.common.termOfProtection')+':'">
          <BjDatePicker v-model="lockForm.protectEndTime" :picker-options="pickerOptions" valueFormat="yyyy-MM-dd 23:59:59" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveProtectTime">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>

    <dialogTrans ref="dialogTransRef" @reFresh="reFresh"/>
  </div>
</template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { userApi,billApi } from '@/api';
  import { STATUS_ENABLED_TRUE, STATUS_FROZEN_TRUE, STATUS_YES_TRUE,STATUS_EXITED_USER } from '@/utils/constants';
  import dialogCompany from '../account/components/DialogCompany';
  import dialogTrans from './components/dialogTrans';
  import { validatePass } from '@/utils';
  import moment from 'moment';
  import { getShippingList } from '@/utils';

  export default {
    name: 'BusinessUserCustomerCSG',
    components: { dialogCompany, dialogTrans },
    mixins: [pageMiXin],
    data() {
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('AccountManagement.common.ps2')));
        } else if (value !== this.form.pass) {
          callback(new Error(this.$t('AccountManagement.common.ps3')));
        } else {
          callback();
        }
      };
      return {
        selection: true,
        queryApi: userApi.getUserNewList,
        // 查询参数
        queryParams: {
          loginName: null,
          realName: null,
          enabled: null,
          locked: null,
          lock: null,
          isDeparture: null,
          activeFlag: null,
          startDateActive: null,
          endDateActive: null,
          customerType: 'C',
          companyName: null,
          csgCustomer:null,
          clientCode: null,
          industryList: null,
        },
        title: '',
        dialogVisible: false,
        /** 修改密码弹窗 */
        passDialogVisible: false,
        // 表单参数
        form: {
          pass: null,
          checkPass: null,
        },
        // 表单校验
        rules: {
          pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
          checkPass: [{ required: true, validator: validatePass2, trigger: 'blur' }],
        },
        labelList: [
          { label: this.$t('AccountManagement.customer.account'), prop: 'clientCode', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.customer.name'), prop: 'realName', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.customer.companyName'), prop: 'companyName', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.customer.status'), prop: 'enabled', isCheck: true, disabled: false, width: 100 },
          { label: this.$t('AccountManagement.common.Whether'), prop: 'locked', isCheck: true, disabled: false, width: 100 },
          { label: this.$t('AccountManagement.common.isfreeze'), prop: 'lock', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('AccountManagement.common.isLeave'), prop: 'isDeparture', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('AccountManagement.common.termOfProtection'), prop: 'protectEndTime', isCheck: true, disabled: false, width: 135 },
          { label: this.$t('AccountManagementAdd.customerInfo.industry'), prop: 'industry', isCheck: true, disabled: false, width: 135 },
          { label: this.$t('AccountManagement.common.cusName'), prop: 'cusName', isCheck: true, disabled: false, width: 160 },
          { label: this.$t('DetailsOfThirdPartySalesOrder.employee'), prop: 'csgSales', isCheck: true, disabled: false, width: 160 },
          { label: this.$t('workOrderList.Customer'), prop:'csgCustomer', isCheck: true, disabled: false,width:125},
          { label: this.$t('AccountManagement.table.creator'), prop: 'createdName', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false, width: 145 },
          { label: this.$t('AccountManagement.customer.activationTime'), prop: 'startDateActive', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.customer.deactivationTime'), prop: 'endDateActive', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
        ],
        // 客服下拉列表
        customerNameList:[],
        STATUS_ENABLED_TRUE,
        STATUS_FROZEN_TRUE,
        STATUS_YES_TRUE,
        STATUS_EXITED_USER,
        clickUserId: null,
        clickCusId: null,
        dialogFormVisible: false,
        lockForm: {
          lockType:1,
          cusId: null,
          protectBeginTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          protectEndTime: '',
          tenantId: this.$store.getters.tenantId,
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date().getTime();
          },
        },
        csgSalesList: [],
      };
    },
    computed:{
      // 客户编码下拉
      newClientCode(){
        return this.clientCodeList.map(item=>{
          return{
            label:  item.clientCode,
            value: item.clientCode
          }
        })
      }
    },
    created(){
      this.getIndustryList()
    },
    methods: {
      // 获取行业类型下拉数据
      getIndustryList(){
        billApi.getCustomerType({dataModel:2}).then(res=>{
          if(res.data.content.length){
            this.industryList = res.data.content.map(item => {
              return { label: item.industry, value: item.industry };
            });
          }
        })
      },
      afterFetchOriginalData(res) {
        if(res.content.length){
          // 获取客服下拉框数据
          this.getCustomerList()
        }
      },
      // 获取客服下拉数据
      getCustomerList(){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
          if(res.content.length){
            this.customerNameList = res.content.map(item => {
              return { label: item.realName, value: item.realName };
            });
            userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Sales'}).then(resp=>{
              if(resp.content.length){
                this.csgSalesList = resp.content.map(item => {
                  return { label: item.realName, value: item.realName };
                });
              }
            })
          }
        })
      },
      lockDisabled(row) {
        return new Date(row.protectEndTime) > new Date();
      },
      rowStyleFun({ row, rowIndex }) {
        const styleJson = {};
        if (row.activeFlag) {
          styleJson.color = 'red';
        }
        return styleJson;
      },
      saveProtectTime() {
        const { cusId, tenantId } = this.lockForm;
        const obj = this.lockForm.protectEndTime ? this.lockForm : { cusId, tenantId, lockType:1 };
        userApi.userCustomerNnlocked(obj).then(res => {
          if (!res.failed) {
            this.dialogFormVisible = false;
            this.msgSuccess(this.$t('AccountManagement.common.ps6'));
            this.reFresh();
          }
        });
      },
      command(TEXT, row) {
        if(TEXT === this.$t('AccountManagement.common.Info')){
          this.toEditPage(row)
          return
        }
        if(TEXT === this.$t('WarehouseManagement.form.Shipping')){
          this.$refs.dialogTransRef.dialogVisible = true;
          getShippingList(row.cusId).then(res=>{
            this.$refs.dialogTransRef.tableData = res.map(item=>{
              return { ...item, isDisable: !item.isDisable }
            })
          })
          return
        }
        if (TEXT === this.$t('AccountManagement.common.unfreeze')) {
          this.lockForm.protectEndTime = '';
          this.dialogFormVisible = true;
          this.lockForm.cusId = row.cusId;
          return;
        }
        this.clickUserId = row.id;
        this.clickCusId = row.cusId;
        if (TEXT === this.$t('AccountManagement.common.structure')) {
          this.$refs.dialogCompany.show(row.id);
          return;
        }
        if (TEXT === this.$t('AccountManagement.common.Change')) {
          this.title = this.$t('AccountManagement.common.Change');
          this.form = {
            pass: null,
            checkPass: null,
          };
          this.passDialogVisible = true;
          return;
        }
        this.$confirm(this.$t('AccountManagement.common.ps4') + ' ' + this.$t(TEXT) + ' ' + `${row.loginName}，` + this.$t('AccountManagement.common.ps5'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('okText'),
          cancelButtonText: this.$t('cancelText'),
          type: 'warning',
        }).then(() => {
            if (TEXT === this.$t('AccountManagement.common.freeze')) {
              userApi.userCustomerLocked({cusId: row.cusId, lockType:1}).then(res => {
                if (!res.failed) {
                  this.msgSuccess(this.$t('AccountManagement.common.ps6'));
                  this.reFresh();
                }
              });
              return;
            }
            if (TEXT === this.$t('enableText')) {
              this.update('userNnfrozen');
            }
            if (TEXT === this.$t('disableText')) {
              this.update('userFrozen');
            }
            if (TEXT === this.$t('AccountManagement.common.lock')) {
              this.update('userLocked');
            }
            if (TEXT === this.$t('AccountManagement.common.deblocking')) {
              this.update('userUnlocked');
            }
            if (TEXT === this.$t('AccountManagement.common.Leave')) {
              this.changeStatusLeave('userLeave');
            }
            if (TEXT === this.$t('AccountManagement.common.Back')) {
              this.changeStatusBack('userBack');
            }
            if (TEXT === this.$t('delText')) {
              this.deleteData(this.clickUserId);
            }
          });
      },
      update(name) {
        userApi[name]({ userId: this.clickUserId })
          .then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('AccountManagement.common.ps6'));
              this.reFresh();
            }
          });
      },
      changeStatusLeave(name) {
        userApi[name]({ cusId: this.clickCusId })
          .then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('AccountManagement.common.ps7'));
              this.reFresh();
            }
          });
      },
      changeStatusBack(name) {
        userApi[name]({ cusId: this.clickCusId })
          .then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('AccountManagement.common.ps6'));
              this.reFresh();
            }
          });
      },
      deleteData(id) {
        userApi
          .deleteUser({ userId: id })
          .then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('AccountManagement.common.ps6'));
              this.reFresh();
            }
          });
      },
      /* 跳转页面 */
      toPage(row) {
        if (row) {
          this.$router.push({
            name: 'BusinessUserCustomerEditCSG',
            query: { userId: row.id ,pageType:'cantEdit'},
          });
        } else {
          this.$router.push({
            name: 'BusinessUserAccountAdd',
          });
        }
      },
      // 带按钮权限跳编辑
      toEditPage(row) {
        if (row) {
          this.$router.push({
            name: 'BusinessUserCustomerEditCSG',
            query: { userId: row.id ,pageType:'canEdit'},
          });
        }
      },
      /** 新增客户 */
      addCustom() {
        this.$router.push({
          name: 'BusinessUserCustomerAddCSG',
          query: { pageType:'canEdit'},
        });
      },
      /** 新增客户 */
      letOffLine() {
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('chooseText'));
          return;
        }
        const ids = this.selectedRows.map(e => e.id);
        this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            // { userIds: ids }
            userApi.userBatchOffline( ids ).then(res => {
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          })
          .catch(() => {});
      },
      /* **********************修改密码部分************************** */
      /**  */
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.adminUpdatePassword({
              password: this.form.checkPass,
              userId: this.clickUserId,
            });
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.passDialogVisible = false;
        this.resetForm('form');
      },
      adminUpdatePassword(data) {
        userApi
          .adminUpdatePassword(data)
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.handleClose();
            }
          });
      },
      handleChangeStartTime(startTime) {
        const { startDateActive, endDateActive } = this.queryParams;
        if (new Date(endDateActive) < new Date(startDateActive)) {
          this.queryParams.endDateActive = null;
        }
      },
      beforeResetSearch() {
        this.queryParams.industryList = null;
        return new Promise(resolve => {
          resolve();
        });
      }
    },
  };
  </script>
  <style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
